module.exports = __webpack_public_path__ + "img/deal.5126bf03.svg";